import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {Accordion as DXAccordion} from 'devextreme-react';


export default class Accordion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedIndex: this.props.selectedIndex,
            selectedItems: this.props.selectedItems || [],
            selectedItemKeys: this.props.selectedItemKeys || [],
        };

        this.itemTitleTemplate = this.itemTitleTemplate.bind(this);
        this.itemTemplate = this.itemTemplate.bind(this);
        this.onOptionChanged = this.onOptionChanged.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.onItemTitleClick = this.onItemTitleClick.bind(this);
    }

    itemTitleTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            ReactDOM.render(tmpl(itemData), element);
        }
    }

    itemTemplate(template_id) {
        var tmpl = window[template_id];
        return function(itemData, itemIndex, element) {
            ReactDOM.render(tmpl(itemData), element);
        }
    }

    onOptionChanged(e) {
        // console.log('onOptionChanged', e.name)
        if (e.name === 'selectedItem') {
            console.log(e.value)
            // this.setState({selectedItem: e.value});
            this.setState({selectedItemKeys: [e.value.id]});
        }
        // if(e.name === 'selectedIndex') {
        //     this.setState({selectedIndex: e.value});
        // }
        /*else if(e.name === 'selectedItemKeys') {
            this.setState({selectedItemKeys: e.value});
        } else if(e.name === 'selectedItems') {
            this.setState({selectedItems: e.value});
        }*/
    }

    onSelectionChanged(e) {
        console.log('onSelectionChanged', e.name)

        // // if(e.name === 'selectedIndex') {
        // //     this.setState({selectedIndex: e.value});
        // // }
        // let newItems = [...this.state.selectedItems];
        // e.removedItems.forEach(item => {
        //     let index = newItems.indexOf(item);
        //     if (index >= 0) {
        //         newItems.splice(index, 1);
        //     }
        // });
        // if (e.addedItems.length) {
        //     newItems = [...newItems, ...e.addedItems];
        // }
        // this.setState({
        //     selectedItems: newItems
        // });
    }

    onItemTitleClick(e) {
        this.setState({
            selectedIndex: e.itemIndex
        })
    }

    render() {
        const dataAttributes = {};
        // if (this.props.loading_state && this.props.loading_state.is_loading) {
        //     dataAttributes['data-dash-is-loading'] = true;
        // }

        let {itemTitleTemplate, itemTemplate} = this.props;

        if (itemTitleTemplate && typeof itemTitleTemplate === 'string'){// && itemTitleTemplate !== 'title'){
            itemTitleTemplate = this.itemTitleTemplate(itemTitleTemplate);
        }

        if (itemTemplate && typeof itemTemplate === 'string' && itemTemplate !== 'item'){
            itemTemplate = this.itemTemplate(itemTemplate);
        }

        return (
            <DXAccordion
                {...omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                itemTitleTemplate={itemTitleTemplate}
                itemTemplate={itemTemplate}
                selectedIndex={this.state.selectedIndex}
                // selectedItem={this.state.selectedItem}
                // selectedItems={this.state.selectedItems}
                // selectedItemKeys={this.state.selectedItemKeys}
                // onSelectionChanged={this.props.onSelectionChanged || this.onSelectionChanged}
                onItemTitleClick={this.props.onItemTitleClick || this.onItemTitleClick}
                // selectedItems={this.state.selectedItems}

                // onOptionChanged={this.props.onOptionChanged || this.onOptionChanged}
            />
        )
    }
}

Accordion.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    /**
     * Specifies the shortcut key that sets focus on the UI component
     */
    accessKey: PropTypes.string,
    /**
     * Specifies whether or not the UI component changes its state when interacting with a user
     */
    activeStateEnabled: PropTypes.bool,
    /**
     * A number specifying the time in milliseconds spent on the animation of the expanding or collapsing of a panel
     */
    animationDuration: PropTypes.number,
    /**
     * Specifies whether all items can be collapsed or whether at least one item must always be expanded
     */
    collapsible: PropTypes.bool,
    /**
     * Binds the UI component to data
     */
    dataSource: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
    /**
     * Specifies whether to render the panel's content when it is displayed. If false, the content is rendered immediately
     */
    deferRendering: PropTypes.bool,
    /**
     * Specifies whether the UI component responds to user interaction
     */
    disabled: PropTypes.bool,
    /**
     * Specifies the global attributes to be attached to the UI component's container element
     */
    elementAttr: PropTypes.object,
    /**
     * Specifies whether the UI component can be focused using keyboard navigation
     */
    focusStateEnabled: PropTypes.bool,
    /**
     * Specifies the UI component's height
     */
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component
     */
    hint: PropTypes.string,
    /**
     * Specifies whether the UI component changes its state when a user pauses on it
     */
    hoverStateEnabled: PropTypes.bool,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a custom component.
     */
    itemComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * The time period in milliseconds before the onItemHold event is raised
     */
    itemHoldTimeout: PropTypes.number,
    /**
     * An alias for the itemTemplate property specified in React. Accepts a rendering function.
     */
    itemRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * An array of items displayed by the UI component
     */
    items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object)]),
    /**
     * Specifies a custom template for items
     */
    itemTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * An alias for the itemTitleTemplate property specified in React. Accepts a custom component.
     */
    itemTitleComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    /**
     * An alias for the itemTitleTemplate property specified in React. Accepts a rendering function.
     */
    itemTitleRender: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies a custom template for item titles
     */
    itemTitleTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies the key property that provides key values to access data items. Each key value must be unique.
     */
    keyExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    /**
     * Specifies whether the UI component can expand several items or only a single item at once
     */
    multiple: PropTypes.bool,
    /**
     * The text or HTML markup displayed by the UI component if the item collection is empty
     */
    noDataText: PropTypes.string,
    /**
     * A function that is executed when the UI component's content is ready and each time the content is changed
     */
    onContentReady: PropTypes.func,
    /**
     * A function that is executed before the UI component is disposed of
     */
    onDisposing: PropTypes.func,
    /**
     * A function used in JavaScript frameworks to save the UI component instance
     */
    onInitialized: PropTypes.func,
    /**
     * A function that is executed when a collection item is clicked or tapped
     */
    onItemClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /**
     * A function that is executed when a collection item is right-clicked or pressed
     */
    onItemContextMenu: PropTypes.func,
    /**
     * A function that is executed when a collection item has been held for a specified period
     */
    onItemHold: PropTypes.func,
    /**
     * A function that is executed after a collection item is rendered
     */
    onItemRendered: PropTypes.func,
    /**
     * A function that is executed when an accordion item's title is clicked or tapped
     */
    onItemTitleClick: PropTypes.func,
    /**
     * A function that is executed after a UI component property is changed
     */
    onOptionChanged: PropTypes.func,
    /**
     * A function that is executed when a collection item is selected or selection is canceled
     */
    onSelectionChanged: PropTypes.func,
    /**
     * Specifies whether to repaint only those elements whose data changed
     */
    repaintChangesOnly: PropTypes.bool,
    /**
     * Switches the UI component to a right-to-left representation
     */
    rtlEnabled: PropTypes.bool,
    /**
     * The index number of the currently selected item
     */
    selectedIndex: PropTypes.number,
    /**
     * The selected item object
     */
    selectedItem: PropTypes.object,
    /**
     * Specifies an array of currently selected item keys
     */
    selectedItemKeys: PropTypes.arrayOf(PropTypes.any),
    /**
     * An array of currently selected item objects
     */
    selectedItems: PropTypes.arrayOf(PropTypes.any),
    /**
     * Specifies the number of the element when the Tab key is used for navigating
     */
    tabIndex: PropTypes.number,
    /**
     * Specifies whether the UI component is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the UI component's width
     */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.func]),

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    // loading_state: PropTypes.shape({
    //     /**
    //      * Determines if the component is loading or not
    //      */
    //     is_loading: PropTypes.bool,
    //     /**
    //      * Holds which property is loading
    //      */
    //     prop_name: PropTypes.string,
    //     /**
    //      * Holds the name of the component that is loading
    //      */
    //     component_name: PropTypes.string,
    // }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

Accordion.defaultProps = {
    accessKey: null,
    activeStateEnabled: false,
    animationDuration: 300, // 300, 200 (Material)
    collapsible: false,
    dataSource: null,
    deferRendering: true,
    disabled: false,
    elementAttr: {},
    focusStateEnabled: false, // false, true (desktop)
    height: 'auto',
    // hint: undefined,
    hoverStateEnabled: true,
    itemComponent: null,
    itemHoldTimeout: 750,
    itemRender: null,
    items: undefined,
    itemTemplate: 'item',
    itemTitleComponent: null,
    itemTitleRender: null,
    itemTitleTemplate: 'title',
    keyExpr: null,
    multiple: false,
    noDataText: 'No data to display',
    onContentReady: null,
    onDisposing: null,
    onInitialized: null,
    onItemClick: null,
    onItemContextMenu: null,
    onItemHold: null,
    onItemRendered: null,
    onItemTitleClick: null,
    onOptionChanged: null,
    onSelectionChanged: null,
    repaintChangesOnly: false,
    rtlEnabled: false,
    selectedIndex: 0,
    selectedItem: null,
    // selectedItemKeys: undefined/
    // selectedItems: undefined/
    tabIndex: 0,
    visible: true,
    width: 'auto'
};
